<template>
    <div class="menu-box">
        <div class="menu">
            <img src="../assets/logo.png" alt="">
            <div class="menu-list">
                <div class="menu-item" :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">HOME</div>
                <div class="menu-item" :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">CORE BUSINESS</div>
                <div class="menu-item" :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">ABOUT US</div>
                <div class="menu-item" :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">CONTACT US</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "Server" }); break;
                case 3: this.$router.push({ path: "AboutUs" }); break;
                case 4: this.$router.push({ path: "ContactUs" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.menu-box {
    padding: 40px 360px;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;

    .menu {
        height: 72px;
        background-color: #fff;
        width: 1500px;
        border-radius: 36px;
        padding: 0px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            height: 32px;
        }

        .menu-list {
            cursor: pointer;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            // padding: 0px 20px;
            display: flex;
            align-items: center;

            .menu-item {
                padding: 0px 20px;
            }

            .select {
                color: #48B774;
                font-weight: bold;
            }
        }
    }
}
</style>